const milestones = [
  {
    year: '2000',
    title: '益維企業創立',
    desc: '於台北南港正式成立，以代理歐美工業控制設備起家，服務台灣石化與製造業客戶。',
  },
  {
    year: '2005',
    title: '擴展防爆設備業務',
    desc: '正式取得多家歐洲防爆認證品牌代理資格，將業務延伸至高風險工況環境，涵蓋化工廠、煉油廠等領域。',
  },
  {
    year: '2010',
    title: '建立技術服務團隊',
    desc: '成立專業工程顧問小組，提供現場勘查、設備選型及安裝技術支援，深化客戶服務深度。',
  },
  {
    year: '2015',
    title: '代理品牌突破 30 家',
    desc: '持續引進歐美優質品牌，產品線涵蓋不銹鋼箱體、GRP 控制箱、變壓器、接線端子等多元工業電氣品類。',
  },
  {
    year: '2020',
    title: '數位化服務升級',
    desc: '全面導入線上詢報價系統，優化客戶服務流程，縮短採購周期，提升整體服務效率與客戶滿意度。',
  },
  {
    year: '2024',
    title: '邁向永續與智慧製造',
    desc: '持續深化與原廠合作，積極引進符合 Industry 4.0 規範的智慧型工業設備，陪伴客戶共同迎向智慧製造時代。',
  },
];

export default function CompanyHistory() {
  return (
    <section className="w-full bg-white py-16 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Section Title */}
        <div className="flex items-center justify-center gap-4 mb-2">
          <span className="text-[#1a73b5] text-2xl leading-none">&#8942;</span>
          <h2 className="text-3xl font-bold text-gray-800 tracking-wider">發展歷程</h2>
          <span className="text-[#1a73b5] text-2xl leading-none">&#8942;</span>
        </div>
        <p className="text-center text-sm tracking-[0.3em] text-gray-400 uppercase mb-10">COMPANY HISTORY</p>

        {/* Divider */}
        <div className="flex items-center mb-14">
          <div className="flex-1 h-px bg-[#1a73b5]" />
          <div className="w-2 h-2 bg-[#1a73b5] rotate-45 mx-1" />
          <div className="flex-1 h-px bg-[#1a73b5]" />
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-1/2 -translate-x-px top-0 bottom-0 w-px bg-[#dde8f5] hidden md:block" />

          <div className="flex flex-col gap-10">
            {milestones.map((m, idx) => {
              const isLeft = idx % 2 === 0;
              return (
                <div
                  key={m.year}
                  className={`flex flex-col md:flex-row items-start md:items-center gap-4 ${
                    isLeft ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  {/* Content Box */}
                  <div className={`flex-1 ${isLeft ? 'md:text-right md:pr-10' : 'md:text-left md:pl-10'}`}>
                    <div className={`inline-block bg-white border border-gray-100 hover:border-[#1a73b5] transition-colors px-5 py-4 w-full md:max-w-xs`}>
                      <h4 className="text-base font-bold text-gray-800 mb-1">{m.title}</h4>
                      <p className="text-sm text-gray-500 leading-[1.9]">{m.desc}</p>
                    </div>
                  </div>

                  {/* Year Dot */}
                  <div className="relative flex flex-col items-center flex-shrink-0 z-10">
                    <div className="w-16 h-16 rounded-full bg-[#1a73b5] flex items-center justify-center shadow-none">
                      <span className="text-white font-bold text-sm">{m.year}</span>
                    </div>
                  </div>

                  {/* Empty side for alternating */}
                  <div className="flex-1 hidden md:block" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
